import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { CancellationResponseErrorCodes, SearchStatus } from '../../../../constants';
import ModalSpinner from '../../../ModalSpinner';
import capitalize from '../../../../helpers/capitalize';
import MarkdownToHtml from '../../../MarkdownToHtml';

const CancelBookingModalSpinner = ({ isModalOpen, mode }) => {
  const {
    cancelBookingStatus,
    cancelBookingError, cancelBookingErrorCode,
  } = useSelector((store) => store.trip);
  const { travelAgency } = useSelector((store) => store.user);
  const cancelSupport = travelAgency
  && travelAgency.settings && travelAgency.settings.tripConfirmationMessages
  && travelAgency.settings.tripConfirmationMessages.cancelFlight ? travelAgency.settings.tripConfirmationMessages.cancelFlight : `Contact ${travelAgency.name} agent  to cancel flight that's already ticketed.`;

  return (
    <ModalSpinner
      isOpen={isModalOpen}
      size="xs"
    >
      {cancelBookingStatus === SearchStatus.SEARCHING && (
        <div className="text-theme gap-2 flex flex-col items-center text-center">
          <CircularProgress color="inherit" />
          Please hold on while we&#39;re cancelling
          {' '}
          <br />
          {' '}
          your
          {' '}
          {mode}
          {' '}
          booking...
        </div>
      )}
      {cancelBookingStatus === SearchStatus.DONE
        && (!cancelBookingError
          ? (
            <p className="text-green-600 gap-2 flex flex-col items-center text-center">
              <FaCheckCircle size={68} />
              {' '}
              {capitalize(mode)}
              {' '}
              booking cancelled!
              <br />
              Searching updated trip confirmation...
            </p>
          )
          : (
            <div className="text-orange-500 gap-2 flex flex-col items-center text-center">
              <p className="flex flex-col items-center">
                <FaTimesCircle size={68} />
                Error in cancel
                {' '}
                {mode}
                {' '}
                booking, please try again.
              </p>
              {cancelBookingError ? (
                <p>
                  {cancelBookingError}
                  {cancelBookingErrorCode && cancelBookingErrorCode
                    .indexOf(CancellationResponseErrorCodes.FLIGHT_TICKETED) > -1
                  && <MarkdownToHtml content={cancelSupport} className="whitespace-normal break-all md:break-normal" />}
                </p>
              ) : null}
            </div>
          ))}
    </ModalSpinner>
  );
};

CancelBookingModalSpinner.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
};

export default CancelBookingModalSpinner;
